import '../sass/post-content.scss';

(() => {
    const $blocks = document.querySelectorAll('.post-content');

    $blocks?.forEach($block => {
        const $video = $block.querySelector('.post-content__video');

        const initVideo = () => {
            if (!$video) return;

            new Plyr($video);
        };

        initVideo();
    });
})();
